import { Construction } from 'lucide-react';

interface MaintenancePageProps {
  message?: string;
}

export default function MaintenancePage({ message }: MaintenancePageProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-amber-50 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center p-4" dir="rtl">
      <div className="text-center max-w-md">
        <div className="bg-orange-100 dark:bg-orange-900/30 w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-6">
          <Construction className="h-12 w-12 text-orange-600 dark:text-orange-400" />
        </div>
        
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
          האתר בתחזוקה
        </h1>
        
        <p className="text-lg text-gray-600 dark:text-gray-300 mb-6">
          {message || 'אנחנו עובדים על שיפורים. נחזור בקרוב!'}
        </p>
        
        <div className="animate-pulse flex justify-center gap-2">
          <div className="w-3 h-3 bg-orange-400 rounded-full"></div>
          <div className="w-3 h-3 bg-orange-500 rounded-full animation-delay-200"></div>
          <div className="w-3 h-3 bg-orange-600 rounded-full animation-delay-400"></div>
        </div>
      </div>
    </div>
  );
}
